<template>
    <header class="header">
		<button v-if="isTablet" class="header__burger" type="button" @click="navbarMenuOpen = !navbarMenuOpen" :class="{active: navbarMenuOpen}">
			<span class="header__burger-icon">
				<span class="header__burger-line"></span>
				<span class="header__burger-line"></span>
				<span class="header__burger-line"></span>
				<span class="header__burger-line"></span>
			</span>
		</button>
		<router-link :to="{name: 'index'}" class="header__logo">
			WELWIN
		</router-link>
		<teleport to="body" :disabled="!isTablet">
			<transition v-if="isTablet" name="fade">
				<div class="navbar__overlay" v-if="navbarMenuOpen" @click="navbarMenuOpen = false"></div>
			</transition>
			<div class="navbar" :class="{open: navbarMenuOpen}" ref="navbar">
				<ul class="navbar__menu">
					<li class="navbar__menu-item" :class="[page === 'index' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'index'}">Главная</router-link>
					</li>
					<li class="navbar__menu-item" :class="[page === 'faq' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'faq'}">FAQ</router-link>
					</li>
					<li class="navbar__menu-item" v-if="user !== null" :class="[page === 'revshare' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'revshare'}">Рефералы</router-link>
					</li>
					<li class="navbar__menu-item" v-if="user !== null" :class="[page === 'bonus' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'bonus'}">Бонусы</router-link>
					</li>
					<li class="navbar__menu-item" :class="[page === 'rang' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'rang'}">Ранги</router-link>
					</li>
					<li class="navbar__menu-item" v-if="user !== null" :class="[page === 'settings' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'settings'}">Настройки</router-link>
					</li>
					<li class="navbar__menu-item" :class="[page === 'history' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'history'}">Выплаты</router-link>
					</li>
					<li class="navbar__menu-item" :class="[page === 'leaderboard' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'leaderboard'}">Топ игроков</router-link>
					</li>
					<li class="navbar__menu-item" :class="[page === 'contacts' ? 'active': '']">
						<router-link class="navbar__menu-link" :to="{name: 'contacts'}">Контакты</router-link>
					</li>
					<li class="navbar__menu-item">
						<a class="navbar__menu-link" :href="$root.$link.reviews" target="_blank">
							Отзывы
						</a>
					</li>
					<li class="navbar__menu-item" v-if="user !== null && user.is_admin" >
						<a class="navbar__menu-link" href="/admin" target="_blank">
							ПУ
						</a>
					</li>
				</ul>
				<div class="navbar__soc">
					<a :href="$root.$link.vk" class="navbar__soc-btn navbar__soc-btn--vk btn" target="_blank">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
						<span v-if="isTablet" >Вконтакте</span>
					</a>
					<a :href="$root.$link.tg" class="navbar__soc-btn navbar__soc-btn--tg btn" target="_blank">
						<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
						<span v-if="isTablet">Telegram</span>
					</a>
				</div>
			</div>
		</teleport>
    </header>
</template>

<script>
import { useUserStore } from '../../stores/User';
import {mapState} from "pinia";
import BreakpointsMixin from "../../mixins/breakpoints-mixin.vue";
import scrollLock from "scroll-lock";


export default {

	mixins: [
		BreakpointsMixin
	],

	data() {
		return {
			currentPage: null,
			navbarMenuOpen: false
		}
	},

	watch: {
		navbarMenuOpen(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.navbar);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.navbar);
				}, 300);
			}
		},

		'$route.path'(newValue, oldValue) {
			if(newValue !== oldValue && this.navbarMenuOpen) {
				this.navbarMenuOpen = false
			}
		}
	},

	computed: {
		...mapState(useUserStore, ['user']),

		page() {
			return this.$route.name;
		}
	},
}
</script>
